export const foundationThemes = {
  light: {
    backgroundHex: '#F8FAFC',
    colorScheme: 'light'
  },
  dark: {
    backgroundHex: '#020617',
    colorScheme: 'dark'
  }
} as const;